export const validate = (state, doctype) => {

    // console.log(state.gender);

    // const genderN = parseInt(state.gender)
    

    return {
      phone: /((8|\+7)-?)?\(?\d{3}\)?-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}/.test(state.telephone),
      // phone: /^[+]?[\s.0-9]*[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(state.telephone),
      // communityPhone: /^['+', '3', '8', ' ', '(', '0', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]$/.test(state.communityPhone),
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(state.email).toLowerCase()),
      gender: /^[0-9]*$/.test('genderN'),
      unzr: /^\d{8}-\d{5}/.test(state.unzrNumber),
      actRecordNumber: /^\d{8}/.test(state.actRecordNumber),
      documentnumber: doctype === 2 ? /^\d{9}/.test(state.documentnumber) : /^\d{6}/.test(state.documentnumber),
      series: doctype === 1 || doctype === 4 || doctype === 99 ? /^[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/.test(state.series) : doctype === 3 ? /^[Ii1]-.{2}$/.test(state.series) : /^[І]-.{2}$/.test(state.series),
      // series: doctype === 1 ? /^[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ].{2}$/.test(state.series) : doctype === 3 ? /^[Ii1]-.{2}$/.test(state.series) : /^[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ].{2}$/.test(state.series),
      dateB: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(state.bithdaydate),
      actRecordDate: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(state.actRecordDate),
      dateofissue: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(state.dateofissue),
      d_doc_stop: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(state.d_doc_stop),
      issuedby: doctype === 2 ? /^\d{4}/.test(state.issuedby) : /^([А-ЕЖ-ЩЬЮЯЇІЄҐ0-9]+[.,]?[ ]?['-]?)*$/.test(state.issuedby),
      p_account: /^\s*(UA)\d{27}/.test(state.p_account)
  
    //   // communityName: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.communityName),
    //   // address: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.address),
    //   // url: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.url),
    //   communityName: /^$|^[0-9a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.’`";:]+$/.test(state.communityName),
    //   address: /^$|^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.’"`,;:]+$/.test(state.address),
      // url: /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(state.url),
    }
  }